module.exports = __webpack_public_path__ + "static/media/mo.01b620c3.svg";